import { Col } from "react-bootstrap";
import { BoxArrowUpRight, Github } from "react-bootstrap-icons";
import reactpng from "../assets/img/figmalogo.png";

function ProjectCard({ title, description, imgUrl, projectLink, linkType = "github" }) {
  const isLiveLink = linkType === "live";
  const linkLabel = isLiveLink ? "Open live site" : "View source on GitHub";

  return (
    <Col size={12} sm={6} md={6} lg={4}>
      <div className="proj-imgbx">
      
        <img
          className="project-img"
          src={imgUrl}
          alt={title}
          loading="lazy"
          decoding="async"
          width="1200"
          height="900"
        />
      
        <div className="proj-txtx">
          <h4>{title}</h4>
          <a
            target="_blank"
            rel="noreferrer"
            href={projectLink}
            className="project-link-btn"
            aria-label={linkLabel}
            title={linkLabel}
          >
            {isLiveLink ? <BoxArrowUpRight size={20} /> : <Github size={20} />}
          </a>
        </div>
      </div>
    </Col>
  )
}

function UiProjectCard({ title, description, imgUrl,projectLink })  {
  return (
    <Col size={12} sm={6} md={6} lg={4}>
      <div className="proj-imgbx">
      
        <img src={imgUrl} alt={title} loading="lazy" decoding="async" width="1200" height="900" />
      
        <div className="proj-txtx">
          <h4>{title}</h4>
  <a target="_blank" rel="noreferrer" href={projectLink}> <img style={{width:"30px",  marginTop:"10px" }} src={reactpng} alt="View design" loading="lazy" decoding="async" /></a>
        </div>
      </div>
    </Col>
  )
}

export { ProjectCard, UiProjectCard };
